/**
 * Capitalizes the first letter of a given string.
 * @param string target string to alter.
 * @returns a new string with the adjusted capitalization
 */
export function capitalizeFirstLetter(string: string) {
  // empty string guard clause.
  if (string === "") return "";
  // lowercase the string.
  const lowerCasedString = string.toLowerCase();
  // capitalize First character and attach remaining characters if there are any then return.
  return (
    lowerCasedString.charAt(0).toUpperCase() + (lowerCasedString.length >= 2 ? lowerCasedString.slice(1) : "")
  );
}
